import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import { nodeParser } from '@kontent-ai/delivery-node-parser';
import { createRichTextHtmlResolver } from '@kontent-ai/delivery-sdk';
import { ImageWrapper } from 'components/wrapper/imageWrapper';
import React, { FunctionComponent } from 'react';
import { withTranslations } from 'store/translations';

import { Contact, FormModal } from '../../../models';
import { getButtonWithLinkStyling } from '../../base/Button';
import { ContactFormModal } from '../../modules/ContactFormModal';

interface ContactGroupItemProps {
  model: Contact;
  form: FormModal;
}

export const ContactGroupItemLandscape: FunctionComponent<ContactGroupItemProps> = ({ model, form }) => {
  const contact = model.elements;
  const contactModal = form;
  const { aria, common } = withTranslations();
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Flex
        flexDirection='row'
        color='mountain.base'
        //maxWidth={'280px'}
        //justifyContent='space-between'
        alignItems={{ base: 'center', md: 'flex-start' }}
        textAlign={{ base: 'left', md: 'left' }}
      >
        <Box order={0} pr={'20px'}>
          <ImageWrapper
            // alt={contact.value}
            imageFrontify={contact?.frontifyImage?.value}
            //   msImage={msImage.value}
            imageSx={{
              mb: { base: 'xs', lg: 's' },
              w: { base: '80px', lg: '100px' },
              h: { base: '80px', lg: '100px' },
            }}
            alt={contact?.displayName?.value}
          />
        </Box>
        <Box>
          {contact?.displayName?.value && (
            <Text as='h3' mb={{ base: '0', lg: '0' }} textStyle='desktop.body.medium.s_gcontact'>
              {contact?.displayName?.value}
            </Text>
          )}
          <Text textStyle={{ base: 'mobile.body.s_g_contact', lg: 'desktop.body.s_gcontact' }}>
            {contact.jobTitle?.value}
          </Text>
          <Text textStyle={{ base: 'mobile.body.s_g_contact', lg: 'desktop.body.s_gcontact' }}>
            {model.elements.market?.value}
          </Text>
          {contactModal &&
            getButtonWithLinkStyling(
              `${aria('openContactGetInTouchWith')} ${contact.displayName}`,
              common('getInTouch'),
              onOpen,
              contactModal.system.name,
              undefined,
              350,
              true,
            )}
          {contactModal && (
            <ContactFormModal
              id={`${model.system.id}${contactModal.system.id}`}
              model={contactModal}
              isOpen={isOpen}
              contactPersonEmail={contact?.email?.value}
              onClose={onClose}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
